import React, { useState, useEffect } from 'react'
import "../Frontend/UserProfile/UserProfile.css";
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';
import APP_CONFIG from '../../config/appConfig';
import useAuth from '../../hooks/useAuth';
import { Form, Button } from 'react-bootstrap';
import { useUser } from '../../context/UserContext';
import ScreenLoader from '../HtmlElements/ScreenLoader';
import Alert from '../HtmlElements/Alert';
import { useConfig } from '../../context/AppConfigContext';
import UserPreferenceSidebar from './UserPreferenceSidebar';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function UserProfile() {
  useAuth();
  const { user } = useUser();

  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  // const [image, setImage] = useState('');
  const [isEmailEditable, setIsEmailEditable] = useState(false);
  const [isPasswordEditable, setIsPasswordEditable] = useState(false);

  const [formData, setFormData] = useState({
    firstname: user?.firstname || '',
    lastname: user?.lastname || '',
    title: user?.title || '',
    designation: user?.designation || '',
    email: user?.email || '',
    // password: user?.password || '',
    company_name: user?.company_name || '',
    phone: user?.phone || '',
    country: user?.country || '',
    email_signature: user?.email_signature || ''
  });

  const navigate = useNavigate();
  const { userId } = useParams();
  const {appConfig} = useConfig();

  useEffect(() => {
      setLoader(true);

      setFormData({
        firstname: user?.firstname || '',
        lastname: user?.lastname || '',
        title: user?.title || '',
        email: user?.email || '',
        // password: user?.password || '',
        designation: user?.designation || '',
        company_name: user?.company_name || '',
        phone: user?.phone || '',
        country: user?.country || '',
        email_signature: user?.email_signature || ''
      });

      setLoader(false);
  }, [user]);

  if(!appConfig){
    return <div> </div>;
  }
  const countryOptions = appConfig.country_options;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Clear the error for the current field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
    // console.log(formData);    
  }

  const handleSignatureChange = (value) => {
    console.log("handleSignatureChange",value)
    setFormData((prev) => ({
      ...prev,
      email_signature: value,
    }));

  setErrors((prevErrors) => ({
    ...prevErrors,
    email_signature: '',
  }));
};


  const validateForm = () => {
    let newErrors = {};

    if (!formData.firstname){
      newErrors.firstname = 'First Name is required';
    }else if(/[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.firstname)){
      newErrors.firstname = 'Special characters are not allowed in First Name';
    }

    if (!formData.lastname){
      newErrors.lastname = 'Last Name is required';
    }else if(/[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.lastname)){
      newErrors.lastname = 'Special characters are not allowed in Last Name';
    }

    if(formData.designation && /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.designation)){
      newErrors.designation = 'Special characters are not allowed in Designation';
    }

    if (isEmailEditable && formData.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = 'Please enter a valid email address';
      }
    }

    if (isPasswordEditable && formData.password) {
      if (formData.password.length < 8) {
        newErrors.password = 'Password must be at least 8 characters';
      } else if (!/[A-Z]/.test(formData.password)) {
        newErrors.password = 'Password must contain at least one uppercase letter';
      } else if (!/[0-9]/.test(formData.password)) {
        newErrors.password = 'Password must contain at least one number';
      } else if (!/[!@#$%^&*]/.test(formData.password)) {
        newErrors.password = 'Password must contain at least one special character (!@#$%^&*)';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return;
    }

    const formattedData = {
      // id: userId,
      // profileImage: image,
      firstname: formData.firstname,
      lastname: formData.lastname,
      title: formData.title,
      designation: formData.designation,
      email: formData.email,
      password: formData.password,
      company_name: formData.company_name,
      phone: formData.phone,
      country: formData.country,
      email_signature: formData?.email_signature || ''
    };

    setLoader(true);    

    try {


      if(formattedData.password){
        delete(formattedData.password);
      }

      const response = await api.post('/users/update_user_info', formattedData);
      if (response.data.status === 201 || response.data.status === 200) {
          sessionStorage.setItem('successMessage', response.data.result.message);

          navigate('/users/personalisation');
      } else {
            setApiError(response.data.result.message || 'An error occurred while saving the user.');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'An error occurred while saving the user.';
      setApiError(errorMsg);
      console.error('Error saving user:', error);
    }
    setLoader(false);
  }

  return (
    <div className='user_profile_wrapper'>
      {loader === true && (<ScreenLoader />)}
      <div className='container-fluid'>
        <div className='user_profile_subblock'>
          {apiError && <Alert type="danger" message={apiError} />}
          <div className='row'>
            {/* <div className='client_head_left'>
              <h5 className="client_head">Client admin login</h5>
            </div> */}
            <div className='col-md-2' style={{borderRight: "solid 0.1rem #98A4AA33"}}>
              <div className='sidebar_profile'>
                <UserPreferenceSidebar />
              </div>
            </div>
            <div className='col-md-10'>
              <div className='userprofile_right' style={{border: 'none'}}>
                <div className='row'>
                  <div className="col-md-12">
                      <Form onSubmit={handleSubmit} className="user_form_info" autoComplete='off'>
                        <div className='row'>
                          {/* <div className='col-md-12'>
                            <div className='user_profile_change mb-3'>
                                <div className='img_profile_block'>
                                  <img
                                    className="profile_picture"
                                    src={APP_CONFIG.AVATAR_URL + "background=0D8ABC&color=fff&name=" + user?.firstname + " " + user?.lastname + '&rounded=true&bold=true&font-size=0.50'}
                                    alt="icon" 
                                  />
                                </div>
                            </div>
                          </div> */}

                          <div className='col-md-6'>
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="firstname"
                                className="form-input"
                                style={{marginLeft : '5px'}}
                                value={formData.firstname}
                                onChange={handleChange}
                              >
                              </Form.Control>
                              <Form.Label className='form-label'>First name</Form.Label>
                            </div>
                            {errors.firstname && <div className="text-danger custom_error_msg pt-2 px-2">{errors.firstname}</div>}                            
                          </div>
                          {/* <div className='col-md-6'></div> */}

                          <div className='col-md-6'>
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="lastname"
                                className="form-input"
                                style={{marginLeft : '5px'}}
                                value={formData.lastname}
                                onChange={handleChange}
                              >
                              </Form.Control>
                              <Form.Label className='form-label'>Last name</Form.Label>
                            </div>
                            {errors.lastname && <div className="text-danger custom_error_msg pt-2 px-2">{errors.lastname}</div>}
                          </div>


                          <div className='col-md-6'></div>
                          <div className='col-md-6'></div>

                          <div className='col-md-6'>
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="title"
                                className="form-input"
                                style={{marginLeft : '5px'}}
                                value={formData.title}
                                onChange={handleChange}
                                // disabled='disabled'
                              ></Form.Control>
                              <Form.Label className='form-label'>Title</Form.Label>
                            </div>
                          </div>

                          <div className='col-md-6'>
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="designation"
                                className="form-input"
                                style={{marginLeft : '5px'}}
                                value={formData.designation}
                                onChange={handleChange}
                              ></Form.Control>
                              <label htmlFor="text" className="form-label">Department </label>
                            </div>
                            {errors.designation && <div className="text-danger custom_error_msg pt-2 px-2">{errors.designation}</div>}
                          </div>


                          <div className='col-md-6'>
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="company_name"
                                className="form-input"
                                style={{marginLeft : '5px'}}
                                value={formData.company_name}
                                disabled='disabled'
                              ></Form.Control>
                              <Form.Label className='form-label'>Company name</Form.Label>
                            </div>
                          </div>

                         
                          <div className='col-md-6'>
                            <div className="form-control-info">
                              <Form.Control
                                className="form-input"
                                as="select"
                                name="country"
                                style={{paddingLeft : '15px'}}
                                value={formData.country}
                                onChange={handleChange}>
                                <option key="" value="">Select Country</option>
                                {Object.keys(countryOptions).map((key) => (
                                  <option key={`country-${key}`} value={key}>{countryOptions[key]}</option>
                                ))}
                              </Form.Control>
                              <label htmlFor="text" className="form-label">Country </label>
                            </div>
                            {errors.country && <div className="text-danger custom_error_msg pt-2 px-2">{errors.country}</div>}
                          </div>
                          <div className='col-md-6'></div>

                          <div className='col-md-6'></div>
                        </div>

                      <div className="col-md-6 mt-3">
                        
                        <div className="form-control-info custom_quill_editor_wrapper">
                      

                          <ReactQuill
                            value={formData.email_signature}
                            onChange={handleSignatureChange}
                            className="custom-quill-editor"
                            modules={{
                              toolbar: [
                                ["bold", "italic", "underline"],
                                [{ list: "ordered" }, { list: "bullet" }],
                                ["link"],
                                ["clean"],
                              ],
                            }}
                            formats={["bold", "italic", "underline", "list", "bullet", "link"]}
                          />
                          <p className='editor_note'>
                          Note: This will be your signature for emails you auto nurture
                          </p>
                          
                        </div>
                      </div>


                        <div className='col-md-12  pt-2'>
                          <div className='prev_next_block'>
                            <Button type='button' href='/clients_accounts' className="previous_btn mr-2">
                              Cancel
                            </Button>
                            <Button type='submit' className="personalisation_button">
                              Next
                            </Button>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
              </div>  
            </div>  
          </div>      
        </div>
      </div>
    </div>
  )
}
